import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  /** Text shown in place of `children` while `loading` is true (e.g. "Signing In…"). */
  loadingLabel?: string;
}

/** Generic button with a built-in loading/disabled state. Justified as a shared primitive because every
 * later Identity auth screen (MFA, password recovery, lockout) needs the identical
 * disabled-while-submitting behavior described in the approved SRS's loading-state requirements. */
export function Button({ loading, loadingLabel, children, disabled, ...rest }: ButtonProps) {
  return (
    <button {...rest} disabled={disabled || loading} aria-busy={loading || undefined}>
      {loading ? (loadingLabel ?? 'Loading…') : children}
    </button>
  );
}
